module.exports = require("sanitize-html");


//////////////////
// WEBPACK FOOTER
// external "sanitize-html"
// module id = 607
// module chunks = 0